const AuctionStatus = {
  SAVE_DRAFT: 0,
  PENDING_APPROVAL: 1,
  APPROVED: 2,
  NOT_APPROVED: 3,
  ANNOUNCED: 4,
  SUCCESS: 5,
  FAIL: 6
};

const RegisterActionStatus = {
  REGISTERED_NOT_APPROVED: 1,
  REGISTERED_APPROVED: 2,
  REGISTERED_REJECTED: 3,
  CANCELLED_REGISTERED: 4
};

const AuctionHistoryStatus = {
  // Rút lại giá đã trả
  WITHDRAW: 0,
  // Trả giá hợp lệ
  VALID: 1,
  // Từ chối trúng giá
  REJECTED: 2
};

const DateFormat = {
  'DD/MM/YYYY': 'DD/MM/YYYY',
  'HH:mm:ss DD/MM/YYYY': 'HH:mm:ss DD/MM/YYYY'
};

export { AuctionStatus, RegisterActionStatus, AuctionHistoryStatus, DateFormat };



// WEBPACK FOOTER //
// ./src/constants/index.js